/* seting */
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const UPDATE_THEME_SETTINGS = 'UPDATE_THEME_SETTINGS'
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
export const SELECT_ENROLL_SUBJECT = 'SELECT_ENROLL_SUBJECT'

//* Auth
export const UPDATE_SELECTED_SEMESTER = 'UPDATE_SELECTED_SEMESTER'
export const UPDATE_SELECTED_ACADEMIC_YEAR = 'UPDATE_SELECTED_ACADEMIC_YEAR'
export const UPDATE_SEMESTER = 'UPDATE_SEMESTER'
export const UPDATE_ACDEMIC_YEAR = 'UPDATE_ACDEMIC_YEAR'

// เลือกรูปแบบการลงทะเบียน
export const SELECT_ENROLL_TYPE = 'SELECT_ENROLL_TYPE'
//invoidId
export const SELECT_INSTALLMENT_TYPE = 'SELECT_INSTALLMENT_TYPE'
export const SET_TAB_FIN_STD = 'SET_TAB_FIN_STD'
export const SET_STEP_FIN_STD = 'SET_STEP_FIN_STD'
export const SET_FIN_STATUS = 'SET_FIN_STATUS'
export const SET_FINE_REG_LATE_FLAG = 'SET_FINE_REG_LATE_FLAG'
export const SET_FINE_CH_REG_LATE_FLAG = 'SET_FINE_CH_REG_LATE_FLAG'
export const SET_SKIP_ALERT_FINE = 'SET_SKIP_ALERT_FINE'
export const SET_CLD_FINE_REG_LATE = 'SET_CLD_FINE_REG_LATE'
export const SET_CLD_FINE_CH_REG_LATE = 'SET_CLD_FINE_CH_REG_LATE'
export const SET_SKIP_ALL_FIN = 'SET_SKIP_ALL_FIN'

//เลือกหมู่เรียน

export const ENROLL_ADD_SECTION = 'ENROLL_ADD_SECTION'
export const ENROLL_REMOVE_SECTION = 'ENROLL_REMOVE_SECTION'

//Calendar
export const UPDATE_CALENDAR = 'UPDATE_CALENDAR'

//* Pre-register
export const SELECT_ENROLL_SUBJECT_PRE = 'SELECT_ENROLL_SUBJECT_PRE'
export const ENROLL_ADD_SECTION_PRE = 'ENROLL_ADD_SECTION_PRE'
export const ENROLL_REMOVE_SECTION_PRE = 'ENROLL_REMOVE_SECTION_PRE'

//* Student Profile
export const SET_STD_EDU_PROFILE = 'SET_STD_EDU_PROFILE'
export const SET_STD_HTR_PROFILE = 'SET_STD_HTR_PROFILE'
export const SET_STD_MJ_CHANGE_PROFILE = 'SET_STD_MJ_CHANGE_PROFILE'

//* Notification
export const SET_FLAG_READ_NOTIFICATION = 'SET_FLAG_READ_NOTIFICATION'
export const SET_STD_KEY_FINE_REG_NOTI_READ = 'SET_STD_KEY_FINE_REG_NOTI_READ'
export const GET_FLAG_NOTI_FINE_REG = 'GET_FLAG_NOTI_FINE_REG'

//* Transfer section or Transfer enroll
export const SET_SRC_SUBJECT = 'SET_SRC_SUBJECT'
export const SET_SRC_SEC_CODE = 'SET_SRC_SEC_CODE'
export const SET_SRC_SEC_TYPE = 'SET_SRC_SEC_TYPE'
export const SET_TGT_SUBJECT = 'SET_TGT_SUBJECT'
export const SET_TGT_SEC_CODE = 'SET_TGT_SEC_CODE'
export const SET_TGT_SEC_TYPE = 'SET_TGT_SEC_TYPE'
export const RESET_TF_OPTS = 'RESET_TF_OPTS'

//* Permission Action.
export const UPDATE_ROLE_ACTION_SCOPE = 'UPDATE_ROLE_ACTION_SCOPE'
export const UPDATE_CURRENT_ROUTE_MENU = 'UPDATE_CURRENT_ROUTE_MENU'
export const UPDATE_ROLE_DATA_SCOPE = 'UPDATE_ROLE_DATA_SCOPE'

export const SET_ROUTE_LIST = 'SET_ROUTE_LIST'

//* Graduate
export const SET_GRD_REQ_DOC_DATA = 'SET_GRD_REQ_DOC_DATA'
export const RESET_GRD_REQ_DOC_DATA = 'RESET_GRD_REQ_DOC_DATA'
export const SET_GRD_REQ_OPEN = 'SET_GRD_REQ_OPEN'
export const SET_GRD_REQ_STD_DATA = 'SET_GRD_REQ_STD_DATA'
export const SET_GRD_REQ_MODE = 'SET_GRD_REQ_MODE'

export const SET_GRD_SEARCH_FILTER = 'SET_GRD_SEARCH_FILTER'
export const RESET_GRD_SEARCH_FILTER = 'RESET_GRD_SEARCH_FILTER'
//curriculum
export const CUR_TQF2_SET_SEARCH_VALUES = 'CUR_TQF2_SET_SEARCH_VALUES'
